import { useDialog } from "lib/@hooks/useDialog"
import { busyWhile } from "lib/@components/busy/busy-while"
import { createRuleSet } from "routes/rule-sets/controller/create-rule-set"
import { updateRuleSet } from "routes/rule-sets/controller/update-rule-set"
import { saveRuleSetContext } from "../rule-sets/rule-set-context-storage"
import { CreateRuleSetInScenarioDialog } from "./create-rule-set-in-scenario-dialog"

export function useCreateRuleSetInScenario() {
    const openDialog = useDialog(<CreateRuleSetInScenarioDialog />, { maxWidth: "md", fullWidth: true })

    return createForScenario

    async function createForScenario(regime) {
        const result = await openDialog({ regime })
        if (!result) return null

        const newSet = await busyWhile(
            () =>
                createRuleSet({
                    name: result.name,
                    description: result.description,
                    defaultAction: result.defaultAction,
                }),
            "Creating rule set..."
        )
        if (!newSet?.id) return null

        // Persist the regime context locally so deeper edits on the rule-set page
        // open with the same regime pre-selected (matches useCreateRuleSet).
        saveRuleSetContext(newSet.id, { regime: result.regime || null, assetRegister: null })

        await busyWhile(
            () =>
                updateRuleSet({
                    id: newSet.id,
                    data: {
                        name: result.name,
                        description: result.description,
                        defaultAction: result.defaultAction,
                        parentRuleSetId: null,
                        rules: stripRules(result.rules),
                    },
                }),
            "Saving rules..."
        )

        return { ...newSet, name: result.name, rules: result.rules }
    }
}

function stripRules(rules) {
    return (rules || []).map(({ __typename, conditions, action, ruleSetName: __ruleSetName, ...rest }) => ({
        ...rest,
        conditions: (conditions || []).map(({ __typename: __ctn, _id: __cid, ...c }) => c),
        action: action ? (({ __typename: __atn, ...a }) => a)(action) : action,
    }))
}
